import { Card, Flex, Typography, Tag, Progress, Space } from 'antd';
import { UserOutlined, FileTextOutlined, CalendarOutlined } from '@ant-design/icons';

export const AuditCard = ({
  onClick,
  status = 'Data Collection',
  title,
  school,
  description,
  progress = 50,
  responses = 0,
  date,
  people = 0,
  files = 0,
  by = 'Admin',
}) => {
  return (
    <Card style={{ boxShadow: '0 2px 8px #f0f1f2', cursor: 'pointer' }} size="small" onClick={onClick}>
      <Space direction="vertical" style={{ width: '100%' }} size={8}>
        <Tag
          style={{
            background: '#fff7d6',
            color: '#b38600',
            border: 'none',
            fontWeight: 500,
            fontSize: 13,
            padding: '2px 12px',
          }}>
          {status}
        </Tag>
        <Typography.Title level={5} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        <Typography.Text style={{ color: '#006b8f', fontWeight: 500, fontSize: 15 }}>{school}</Typography.Text>
        <Typography.Text style={{ display: 'block', marginBottom: 8 }}>{description}</Typography.Text>
        <Flex align="center" justify="space-between" style={{ marginBottom: 4 }}>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            Progress
          </Typography.Text>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            {responses} responses
          </Typography.Text>
        </Flex>
        <Progress percent={50} showInfo={false} strokeColor="#006b8f" trailColor="#e6eaf1" size="small" />
        <Flex align="center" justify="space-between" style={{ marginTop: 8 }}>
          <Space size={16}>
            <span>
              <CalendarOutlined style={{ marginRight: 4 }} />
              {date}
            </span>
            <span>
              <UserOutlined style={{ marginRight: 4 }} />
              {people}
            </span>
            <span>
              <FileTextOutlined style={{ marginRight: 4 }} />
              {files}
            </span>
          </Space>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            by {by}
          </Typography.Text>
        </Flex>
      </Space>
    </Card>
  );
};
